import '@didaskill/services/sentry/react';

import ReactDOM from 'react-dom/client';

import {
  bootstrapLocaleAdapter,
  getDefaultLocale,
  makeLocalStorageAdapter,
  setAppLocale,
} from '@didaskill/utils/web';

import config from './config/env';
import App from './react/context';
import { importLocale } from './services/intl';

const initLocale = async () => {
  bootstrapLocaleAdapter(makeLocalStorageAdapter, config.app.name);
  const locale = getDefaultLocale();
  await importLocale(locale);
  setAppLocale(locale);
};

(async function main() {
  await initLocale();

  ReactDOM.createRoot(document.getElementById('root')).render(<App />);
})();
